import { KizenTypography } from '__app/typography';
import { StepCard } from '../StepCard';
import { type CardProps } from '../types';
import { TFunction, useTranslation } from 'react-i18next';
import { StepCardOld } from '../StepCardOld';

export const content = ({ t }: { t: TFunction }) => {
  return t('Unknown');
};

export default function ErrorCard({ type, step, ...others }: CardProps) {
  const { t } = useTranslation();

  const CardComponent = others.isSmartConnectorFlow ? StepCardOld : StepCard;
  return (
    <CardComponent {...others}>
      <KizenTypography as="span">{content({ t })}</KizenTypography>
    </CardComponent>
  );
}
